import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL_V3, post } from "../api";

export interface BillDataPurchasePayload {
  pin: string;
  phone: string;
  service_type: string;
  plan_code: string;
  amount: number;
  payment_option_code: string;
  agentReference: string;
}

/**
 * Data purchase via the provider-agnostic bills layer (/v3/bills).
 */
function useBillDataPurchase(
  options?: MutationOptions<APIResponse<any>, APIError, BillDataPurchasePayload>
) {
  const {
    mutate: purchaseData,
    isLoading: purchasingData,
    isError: isPurchaseError,
    error: purchaseError,
    data: purchaseResponse,
  } = useMutation<APIResponse<any>, APIError, BillDataPurchasePayload>(
    (payload) =>
      post(API_URL_V3 + "/bills/data/purchase", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    purchaseData,
    purchasingData,
    isPurchaseError,
    purchaseError,
    purchaseResponse,
  };
}

export default useBillDataPurchase;
